import { render, staticRenderFns } from "./MediaGroupMediaViewOriginal.vue?vue&type=template&id=3ee4f425&"
import script from "./MediaGroupMediaViewOriginal.vue?vue&type=script&lang=js&"
export * from "./MediaGroupMediaViewOriginal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports